import { useState } from "react";
import { useTranslation } from "react-i18next";

const LOGO_URL = "https://static.readdy.ai/image/76abf0d92622af9fc4827e62ca023833/9bd36fccc1442f12a415c76af596da08.jpeg";
const ADMIN_PASSWORD = "Lkjhgfdsa1969@&$";

interface AdminLoginProps {
  onLogin: () => void;
}

export default function AdminLogin({ onLogin }: AdminLoginProps) {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [showPw, setShowPw] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      sessionStorage.setItem("admin_auth", "true");
      onLogin();
    } else {
      setError(true);
      setPassword("");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-sm bg-white rounded-2xl border border-gray-100 p-8">
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 flex items-center justify-center rounded-xl overflow-hidden mb-4">
            <img src={LOGO_URL} alt="Logo" className="w-full h-full object-cover" />
          </div>
          <h1 className="text-xl font-bold text-slate-800">{t("admin_login_title")}</h1>
          <p className="text-slate-400 text-sm mt-1">{t("nav_brand")}</p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">
              {t("admin_password_label")}
            </label>
            <div className="relative">
              <input
                type={showPw ? "text" : "password"}
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(false); }}
                placeholder={t("admin_password_placeholder")}
                className={`w-full h-11 px-4 pr-10 rounded-lg border text-sm outline-none transition-colors ${
                  error ? "border-red-300 bg-red-50" : "border-gray-200 focus:border-emerald-400"
                }`}
              />
              <button
                type="button"
                onClick={() => setShowPw(!showPw)}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-slate-400 cursor-pointer"
              >
                <i className={showPw ? "ri-eye-off-line" : "ri-eye-line"} />
              </button>
            </div>
            {error && (
              <p className="text-red-500 text-xs mt-1.5">{t("admin_login_error")}</p>
            )}
          </div>

          <button
            type="submit"
            className="h-11 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            {t("admin_login_btn")}
          </button>
        </form>


      </div>
    </div>
  );
}
